import { render, staticRenderFns } from "./CustomerPwaActionBar.vue?vue&type=template&id=55ff794a"
import script from "./CustomerPwaActionBar.vue?vue&type=script&lang=js"
export * from "./CustomerPwaActionBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports